export default "__VITE_ASSET__1d39ccde__"